import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import Root from './containers/Root.jsx'
//import 'bootstrap/dist/css/bootstrap-theme.css';
//import { Router, Route, browserHistory } from 'react-router'
//import createHistory from 'history/createBrowserHistory'
//const history = createHistory()
//import './index.css';


ReactDOM.render(<Root />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js